// modules/DropdownSelectField.jsx
import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  FormHelperText,
} from "@mui/material";

const DropdownSelectField = ({
  module,
  value,
  isEditable,
  onChange,
  fieldKey,
}) => {
  // Default to empty array for multiple selections, or empty string for single selection
  const selectedValue = value || (module.multiple ? [] : "");

  return (
    <FormControl
      fullWidth
      margin="normal"
      required={module.required}
      disabled={!isEditable}
    >
      <InputLabel>{module.label}</InputLabel>
      <Select
        multiple={module.multiple}
        value={selectedValue}
        onChange={(e) => onChange(fieldKey, e.target.value)}
        renderValue={(selected) =>
          Array.isArray(selected) ? selected.join(", ") : selected
        }
      >
        {module.options.map((option, idx) => (
          <MenuItem key={idx} value={option.value}>
            {module.multiple && (
              <Checkbox checked={selectedValue.includes(option.value)} />
            )}
            <ListItemText primary={option.label} />
          </MenuItem>
        ))}
      </Select>
      {module.required &&
        (!selectedValue ||
          (Array.isArray(selectedValue) && selectedValue.length === 0)) && (
          <FormHelperText error>
            Please select at least one option
          </FormHelperText>
        )}
    </FormControl>
  );
};

export default DropdownSelectField;
